import { createContext, useContext } from 'react';

export const AuthContext = createContext({
  isAuthenticated: false,
  user: null,
  login: () => {},
  logout: () => {},
  getToken: () => null,
  hasRole: (role) => Boolean(role),
  token: null,
  slackId: null,
  superAdmin: false
});

export const useAuth = () => useContext(AuthContext);
